'use client';

import { FC, useState } from 'react';
import { useFormStatus } from 'react-dom';

import { getOr } from 'src/utils/getOr';

import { InputFormProps } from './Input.type';
import { InputMasked } from './InputMasked';

/**
 * Input field expected to be used within a React Form
 */
export const InputMaskedForm: FC<InputFormProps<typeof InputMasked>> = ({
  id,
  name,
  disabled,
  formState,
  defaultValue,
  ...props
}) => {
  const inputId = id ?? name;
  const error = getOr(formState, `errors.${name}[0]`, null);
  const { pending } = useFormStatus();
  const [value, setValue] = useState<string>(defaultValue ?? '');

  return (
    <InputMasked
      {...props}
      id={inputId}
      name={name}
      error={error}
      disabled={disabled || pending}
      value={value}
      onChange={setValue}
    />
  );
};
